/* tslint:disable */
/* eslint-disable */
export enum AggregatorIntegrationType {
  Aggregator = 'AGGREGATOR',
  PartnerIntegration = 'PARTNER_INTEGRATION'
}
